import React, { useState } from "react";
import Icon from "./Icon";

// --- Contact Modal Component ---
const ContactModal = ({ isOpen, onClose }) => {
  const [copiedEmail, setCopiedEmail] = useState(false);
  const [copiedPhone, setCopiedPhone] = useState(false);

  const copyToClipboard = (text, setCopied) => {
    const tempInput = document.createElement("textarea");
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-slate-800 rounded-lg shadow-2xl w-full max-w-md p-8 relative border border-slate-700"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-white"
        >
          <Icon name="x" className="w-8 h-8" />
        </button>
        <h2 className="text-2xl font-bold text-white mb-6">
          Contact Information
        </h2>
        <div className="space-y-4">
          <div className="flex items-center justify-between bg-slate-900 p-3 rounded-lg">
            <span className="text-slate-300 flex items-center gap-3">
              <Icon name="mail" className="w-5 h-5 text-cyan-400" />{" "}
              contacto@alangeronimo.com
            </span>
            <button
              onClick={() =>
                copyToClipboard("contacto@alangeronimo.com", setCopiedEmail)
              }
              className="text-slate-400 hover:text-white"
            >
              <Icon name={copiedEmail ? "check" : "copy"} className="w-5 h-5" />
            </button>
          </div>
          <div className="flex items-center justify-between bg-slate-900 p-3 rounded-lg">
            <span className="text-slate-300 flex items-center gap-3">
              <Icon name="phone" className="w-5 h-5 text-cyan-400" /> (+51)
              906471403
            </span>
            <button
              onClick={() => copyToClipboard("+51906471403", setCopiedPhone)}
              className="text-slate-400 hover:text-white"
            >
              <Icon name={copiedPhone ? "check" : "copy"} className="w-5 h-5" />
            </button>
          </div>
          <a
            href="https://www.linkedin.com/in/alan-geronimo-sanes/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between bg-slate-900 p-3 rounded-lg hover:bg-slate-700 transition-colors w-full"
          >
            <span className="text-slate-300 flex items-center gap-3">
              <Icon name="linkedin" className="w-5 h-5 text-cyan-400" /> Visit
              my LinkedIn
            </span>
            <Icon name="arrowUpRight" className="w-5 h-5 text-slate-400" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
